import { Stack } from '@mui/system';
import { EnumCountry, mapCountry } from 'tdc-web-backend/enums/enums';
import { Dispatch, SetStateAction } from 'react';
import CustomChip from '../../../../../../../../../components/custom-chip/CustomChip';
import { truncate } from '../../../../../../../../../utils/helpers';
import CompanyTargetMarketsEditModal from './components/CompanyTargetMarketsEditModal';
import useUserCompany from '../../../../../../../../../utils/hooks/useUserCompany';
import { CHIP_LABEL_TRUNCATE_VALUE } from '../../../../../../../../../utils/constants';

interface CompanyTargetMarketsProps {
  isEditModalOpen: boolean;
  setIsEditModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CompanyTargetMarkets = ({
  isEditModalOpen,
  setIsEditModalOpen,
}: CompanyTargetMarketsProps) => {
  const { company: companyData } = useUserCompany();

  return (
    <Stack
      direction="row"
      gap={1}
      flexWrap="wrap"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      {companyData?.targetCountries?.map((market: EnumCountry) => (
        <CustomChip
          key={market}
          tooltipTitle={mapCountry.get(market)}
          label={
            market &&
            truncate(mapCountry.get(market) as string, CHIP_LABEL_TRUNCATE_VALUE as number)
          }
          sx={{ width: 'fit-content', textTransform: 'capitalize' }}
        />
      ))}

      {companyData && (
        <CompanyTargetMarketsEditModal
          isEditModalOpen={isEditModalOpen}
          setIsEditModalOpen={setIsEditModalOpen}
        />
      )}
    </Stack>
  );
};

export default CompanyTargetMarkets;
